import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
import preferencesA95905 from './preferences'
/**
* @see \App\Http\Controllers\NotificationsController::index
* @see app/Http/Controllers/NotificationsController.php:21
* @route '/notifications'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/notifications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\NotificationsController::index
* @see app/Http/Controllers/NotificationsController.php:21
* @route '/notifications'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\NotificationsController::index
* @see app/Http/Controllers/NotificationsController.php:21
* @route '/notifications'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::index
* @see app/Http/Controllers/NotificationsController.php:21
* @route '/notifications'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\NotificationsController::index
* @see app/Http/Controllers/NotificationsController.php:21
* @route '/notifications'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::index
* @see app/Http/Controllers/NotificationsController.php:21
* @route '/notifications'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::index
* @see app/Http/Controllers/NotificationsController.php:21
* @route '/notifications'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\NotificationsController::unread
* @see app/Http/Controllers/NotificationsController.php:57
* @route '/notifications/unread'
*/
export const unread = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: unread.url(options),
    method: 'get',
})

unread.definition = {
    methods: ["get","head"],
    url: '/notifications/unread',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\NotificationsController::unread
* @see app/Http/Controllers/NotificationsController.php:57
* @route '/notifications/unread'
*/
unread.url = (options?: RouteQueryOptions) => {
    return unread.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\NotificationsController::unread
* @see app/Http/Controllers/NotificationsController.php:57
* @route '/notifications/unread'
*/
unread.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: unread.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::unread
* @see app/Http/Controllers/NotificationsController.php:57
* @route '/notifications/unread'
*/
unread.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: unread.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\NotificationsController::unread
* @see app/Http/Controllers/NotificationsController.php:57
* @route '/notifications/unread'
*/
const unreadForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: unread.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::unread
* @see app/Http/Controllers/NotificationsController.php:57
* @route '/notifications/unread'
*/
unreadForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: unread.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::unread
* @see app/Http/Controllers/NotificationsController.php:57
* @route '/notifications/unread'
*/
unreadForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: unread.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

unread.form = unreadForm

/**
* @see \App\Http\Controllers\NotificationsController::preferences
* @see app/Http/Controllers/NotificationsController.php:79
* @route '/notifications/preferences'
*/
export const preferences = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preferences.url(options),
    method: 'get',
})

preferences.definition = {
    methods: ["get","head"],
    url: '/notifications/preferences',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\NotificationsController::preferences
* @see app/Http/Controllers/NotificationsController.php:79
* @route '/notifications/preferences'
*/
preferences.url = (options?: RouteQueryOptions) => {
    return preferences.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\NotificationsController::preferences
* @see app/Http/Controllers/NotificationsController.php:79
* @route '/notifications/preferences'
*/
preferences.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preferences.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::preferences
* @see app/Http/Controllers/NotificationsController.php:79
* @route '/notifications/preferences'
*/
preferences.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: preferences.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\NotificationsController::preferences
* @see app/Http/Controllers/NotificationsController.php:79
* @route '/notifications/preferences'
*/
const preferencesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preferences.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::preferences
* @see app/Http/Controllers/NotificationsController.php:79
* @route '/notifications/preferences'
*/
preferencesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preferences.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\NotificationsController::preferences
* @see app/Http/Controllers/NotificationsController.php:79
* @route '/notifications/preferences'
*/
preferencesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preferences.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

preferences.form = preferencesForm

/**
* @see \App\Http\Controllers\NotificationsController::readAll
* @see app/Http/Controllers/NotificationsController.php:151
* @route '/notifications/read-all'
*/
export const readAll = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: readAll.url(options),
    method: 'post',
})

readAll.definition = {
    methods: ["post"],
    url: '/notifications/read-all',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\NotificationsController::readAll
* @see app/Http/Controllers/NotificationsController.php:151
* @route '/notifications/read-all'
*/
readAll.url = (options?: RouteQueryOptions) => {
    return readAll.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\NotificationsController::readAll
* @see app/Http/Controllers/NotificationsController.php:151
* @route '/notifications/read-all'
*/
readAll.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: readAll.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NotificationsController::readAll
* @see app/Http/Controllers/NotificationsController.php:151
* @route '/notifications/read-all'
*/
const readAllForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: readAll.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NotificationsController::readAll
* @see app/Http/Controllers/NotificationsController.php:151
* @route '/notifications/read-all'
*/
readAllForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: readAll.url(options),
    method: 'post',
})

readAll.form = readAllForm

/**
* @see \App\Http\Controllers\NotificationsController::read
* @see app/Http/Controllers/NotificationsController.php:140
* @route '/notifications/{notification}/read'
*/
export const read = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: read.url(args, options),
    method: 'post',
})

read.definition = {
    methods: ["post"],
    url: '/notifications/{notification}/read',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\NotificationsController::read
* @see app/Http/Controllers/NotificationsController.php:140
* @route '/notifications/{notification}/read'
*/
read.url = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { notification: args }
    }

    if (Array.isArray(args)) {
        args = {
            notification: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        notification: args.notification,
    }

    return read.definition.url
            .replace('{notification}', parsedArgs.notification.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\NotificationsController::read
* @see app/Http/Controllers/NotificationsController.php:140
* @route '/notifications/{notification}/read'
*/
read.post = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: read.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NotificationsController::read
* @see app/Http/Controllers/NotificationsController.php:140
* @route '/notifications/{notification}/read'
*/
const readForm = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: read.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NotificationsController::read
* @see app/Http/Controllers/NotificationsController.php:140
* @route '/notifications/{notification}/read'
*/
readForm.post = (args: { notification: string | number } | [notification: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: read.url(args, options),
    method: 'post',
})

read.form = readForm

const notifications = {
    index: Object.assign(index, index),
    unread: Object.assign(unread, unread),
    preferences: Object.assign(preferences, preferencesA95905),
    readAll: Object.assign(readAll, readAll),
    read: Object.assign(read, read),
}

export default notifications